export default {
  get: {
    funKey: 'get',
    name: '查看全部',
    apis: [{
      path: '/basis/worker/detail',
      method: 'GET'
    }]
  },
  getMyOrg: {
    funKey: 'getMyOrg',
    name: '查看本机构下的',
    apis: [{
      path: '/basis/worker/detail/my_org',
      method: 'GET'
    }]
  },
  getMyOrgContainChild: {
    funKey: 'getMyOrgContainChild',
    name: '查看本机构及其子机构下的',
    apis: [{
      path: '/basis/worker/detail/my_org_contain_child',
      method: 'GET'
    }]
  }
}